'use client';

/**
 * Accordion FAQ for vehicle decoration landing pages.
 * Content is supplied via `items` (see `vehicleDecorationFaq.ts`).
 */

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import type { VehicleDecorationFaqItem } from '@/data/vehicleDecorationFaq';
import { Plus } from 'lucide-react';
import Link from 'next/link';

type VehicleDecorationFaqProps = {
  items: VehicleDecorationFaqItem[];
  allQuestionsHref: string;
};

export default function VehicleDecorationFaq({
  items,
  allQuestionsHref,
}: VehicleDecorationFaqProps) {
  return (
    <div className="mx-auto w-full flex flex-col gap-6">
      <p className="text-sm md:text-base text-hzc_beige_800 leading-6">
        Düğün gününüzde aracınız için süsleme süreci hakkında merak ettiklerinizi burada
        bulabilirsiniz. Tasarım seçimi, randevu oluşturma ve aranjman gibi tüm detaylar için
        sorularınızı yanıtlıyoruz.
      </p>
      <Accordion type="single" collapsible className="w-full flex flex-col gap-2">
        {items.map((item, index) => (
          <AccordionItem
            key={`vehicle-decoration-faq-${index}`}
            value={`faq-${index}`}
            className="group border border-hzc_border_secondary/60 rounded-xl px-4 md:px-5 bg-white data-[state=open]:shadow-sm"
          >
            <AccordionTrigger className="text-left py-4 hover:no-underline gap-3 [&>svg:last-child]:hidden">
              <span className="font-semibold text-hzc_beige_900 text-sm md:text-base flex-1 pr-2">
                {item.question}
              </span>
              <Plus className="h-5 w-5 shrink-0 text-hzc_beige_800 transition-transform duration-200 group-data-[state=open]:rotate-45" />
            </AccordionTrigger>
            <AccordionContent className="text-hzc_beige_800 text-sm leading-relaxed pb-4">
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <div className="flex justify-center pt-2">
        <Link
          href={allQuestionsHref}
          className="inline-flex items-center justify-center px-4 py-3 text-sm font-medium bg-hzc_purple_500 text-hzc_beige_100 rounded-full w-full sm:w-[344px] hover:bg-hzc_purple_600 transition-colors"
        >
          Şimdi Ürünleri Keşfet
        </Link>
      </div>
    </div>
  );
}
